$(function(){
   $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll > 700) {
        $('.header2').fadeIn();
      }else{
        $('.header2').fadeOut();
      }
   });
});

//メニュー開閉時のアクション、スムーススクロールより下に記述しない
/*$(function(){
   if (window.matchMedia('(max-width:640px)').matches) {
      var $body = $('body');
   }else{
      var $body = $('.wrap');
   }
   var scrollTop;

   function bodyFixedOn() {
      scrollTop = $(window).scrollTop();

      $body.css({
         position: 'fixed',
         top: -scrollTop,
         'overflow-y': 'hidden'
      });
   }

   function bodyFixedOff() {
      if (window.matchMedia('(max-width:640px)').matches) {
         $body.css({
            position: '',
            top: '',
            'overflow-y': ''
         });
      }else{
         $body.css({
            position: 'relative',
            top: '',
            'overflow-y': ''
         });
      }
         
      $(window).scrollTop(scrollTop);
   }
   $(".header__btn .openbtn1").click(function(){
      $(this).toggleClass("active");
      if($(".gloavlmenu__area").hasClass("active")){
         bodyFixedOff();
         $(".gloavlmenu__area").removeClass("active");
      }else{
         bodyFixedOn();
         $(".gloavlmenu__area").addClass("active");
      }
   })

   $(".gloavlmenu__listitem a").click(function(){
      bodyFixedOff();
      $(".gloavlmenu__area").removeClass("active");
      $(".header__btn .openbtn1").removeClass("active");
   });
})*/

$(function(){
   var $body = $('body');
   var scrollTop;

   function bodyFixedOn() {
      scrollTop = $(window).scrollTop();

      $body.css({
         position: 'fixed',
         top: -scrollTop,
         'overflow-y': 'hidden'
      });
   }

   function bodyFixedOff() {
      if (window.matchMedia('(max-width:640px)').matches) {
         $body.css({
            position: '',
            top: '',
            'overflow-y': ''
         });
      }else{
         $body.css({
            position: 'relative',
            top: '',
            'overflow-y': ''
         });
      }
         
      $(window).scrollTop(scrollTop);
   }
   $(".header__btn .openbtn1").click(function(){
      $(this).toggleClass("active");
      if($(".gloavlmenu__area").hasClass("active")){
         bodyFixedOff();
         $(".gloavlmenu__area").removeClass("active");
      }else{
         bodyFixedOn();
         $(".gloavlmenu__area").addClass("active");
      }
   })

   $(".gloavlmenu__listitem a").click(function(){
      bodyFixedOff();
      $(".gloavlmenu__area").removeClass("active");
      $(".header__btn .openbtn1").removeClass("active");
   });

   $(".bgcontent-middle__menuitem a").click(function(){
      bodyFixedOff();
      $(".gloavlmenu__area").removeClass("active");
      $(".header__btn .openbtn1").removeClass("active");
   });
})

// ページ内スクロール
$(function(){
   if (window.matchMedia('(max-width:640px)').matches) {
      $('a[href^="#"]').click(function () {
         const speed = 600;
         let href = $(this).attr("href");
         let target = $(href == "#" || href == "" ? "html" : href);
         let position = target.offset().top - 100 + "px";
         $("body,html").animate({ scrollTop: position }, speed, "swing");
         return false;
      });
   } else if (window.matchMedia('(min-width:641px)').matches) {
      $('a[href^="#"]').click(function () {
         const speed = 600;
         let href = $(this).attr("href");
         let target = $(href == "#" || href == "" ? "html" : href);
         let position = target.offset().top - 100 + "px";;
         $("body,html").animate({ scrollTop: position }, speed, "swing");
         return false;
      });
   }
});

//背景要素高さ調節
$(function(){
   var windowHeight = document.documentElement.clientHeight;
   if(windowHeight <= 800){
      $(".bgcontent-middle__title").css("scale","0.9");
      $(".bgcontent-bottom__phone").css("transform","translateY(7%) scale(0.8)");
      $(".bgcontent-bottom__img").css("transform","translateY(7%) scale(0.8)");
   }
   if(windowHeight <= 750){
      $(".bgcontent-middle").css("margin-top","-45px");
      $(".bgcontent-middle__menuarea").css("margin-top","-20px");
   }
})
//profile上の余白調節
$(function(){
   var kiyoHeight = $(".mv__kiyo").height();
   if (window.matchMedia('(max-width:640px)').matches) {
      var halfHeight = (kiyoHeight * 3) / 10;
   }else if (window.matchMedia('(min-width:641px)').matches) {
      var halfHeight = (kiyoHeight * 2) / 5;
   }
   $(".profile").css("padding-top",halfHeight);
})

//ipadファーストビュー調節
$(function(){
   var windowHeight = document.documentElement.clientHeight;
   if (window.matchMedia('(max-width: 1050px) and (min-width:641px)').matches) {
      if(windowHeight >= 1000){
         $(".mv").css("height","100%");
         $(".profile").css("padding-top","20px");
      }else if(windowHeight <= 800){
         $(".mv").css("height","100%");
         $(".profile").css("padding-top","20px");
      }
   }
});


//メニューハイライト
$(function(){
   $(window).scroll(function(){
         if(($("#menucontent01").offset().top < $(window).scrollTop() + 300) && ($(window).scrollTop() + 300 < $("#menucontent02").offset().top)){
            var filter = "menu01";
         }else if(($("#menucontent02").offset().top < $(window).scrollTop() + 300) && ($(window).scrollTop() + 300 < $("#menucontent03").offset().top)){
            var filter = "menu02";
         }else if(($("#menucontent03").offset().top < $(window).scrollTop() + 300) ){
            var filter = "menu03";
         }
         $(".bgcontent-middle__menuitem").removeClass("active");
         $("#"+filter).addClass("active");
   });
});